import InstanceResponseDialog from './InstanceResponseDialog';

export default InstanceResponseDialog;
